module.exports = __webpack_public_path__ + "img/apply2.f73aafcd.png";